import {
  ButtonComp,
  FormikSelectComp,
  TextInputComp,
  MoneyInputComp,
  CardComp,
} from "../../../../components";
import { Formik, Form } from "formik";
import { useCreateFineMutation } from "../../../../store/admin/settings/fineSlice";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function CreateFineSetting({ 
  categories = [], 
  isLoading, 
  initialCategoryId, 
  initialCategoryName,
  initialData,
  onSubmit,
  isUpdating: isUpdatingProp
}) {
  const [createFine, { isLoading: isCreating }] = useCreateFineMutation();
  const navigate = useNavigate();

  const isEdit = !!initialData;

  const handleSubmit = async (values) => {
    if (onSubmit) {
      return onSubmit(values);
    }

    try {
      const result = await createFine(values).unwrap();
      if (result.status) {
        toast.success(result.message || "Fine created successfully");
        navigate("/super_admin/settings/fine_settings");
      } else {
        toast.error(result.message || "Failed to create fine");
      }
    } catch (error) {
      toast.error(error?.data?.message || "An error occurred");
    }
  };

  return (
    <>
      <div className="py-1"></div>
      <CardComp cardBodyClassName={"py-0"} cardClassName={"pt-4"}>
        <h4 className=" text-black1 fw-bold">
          {isEdit ? `Edit Fine: ${initialData.name}` : (initialCategoryName ? `Configure ${initialCategoryName} Fine` : "Create Fine")}
        </h4>
      </CardComp>
      <div>
        <Formik
          onSubmit={handleSubmit}
          initialValues={{ 
            name: initialData?.name || (initialCategoryName ? `${initialCategoryName} Fee` : ""), 
            fine_category_id: initialData?.fine_category_id || initialCategoryId || "", 
            amount: initialData?.amount || "",
            status_change_window: initialData?.status_change_window || 30
          }}
          enableReinitialize
        >
          {({ values, setFieldValue }) => (
            <Form>
              <CardComp
                cardBodyClassName={"py-0 row gx-5 gy-3 justify-content-between"}
                cardClassName={"pt-4"}
              >
                <div className="col-12 col-lg-5">
                  <div className="mb-3">
                    <TextInputComp
                      LabelText={"Name of fine"}
                      LabelClassName={"fw-bold"}
                      placeholder={"Input fees name"}
                      name="name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <FormikSelectComp
                      labelText={"Fine category"}
                      labelClassName={"fw-bold"}
                      selectText={isLoading ? "Loading categories..." : "Select fine category"}
                      options={categories?.map(cat => ({ label: cat.name, value: cat.id })) || []}
                      fieldName="fine_category_id"
                      required
                      disabled={!!initialCategoryId || isEdit}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-5">
                  <div className="mb-3">
                    <MoneyInputComp
                      LabelText={"Amount"}
                      LabelClassName={"fw-bold"}
                      placeholder={"Input fine amount"}
                      name="amount"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <TextInputComp
                      LabelText={"Status Change Window (Days)"}
                      LabelClassName={"fw-bold"}
                      placeholder={"e.g. 30"}
                      name="status_change_window"
                      type="number"
                      min="1"
                      required
                    />
                    <small className="text-muted">
                      Number of days from attendance date during which an admin can still edit the status.
                    </small>
                  </div>
                </div>
              </CardComp>
              <div className="col-12 py-1"></div>
              <div className="d-flex">
                <ButtonComp
                  btnText={isEdit ? "Update Fine" : "Submit"}
                  btnClassName={
                    "w-100 bg-primary1 py-3 px-4 text-white border-0 rounded"
                  }
                  type={"submit"}
                  loading={isCreating || isUpdatingProp}
                  disabled={isCreating || isUpdatingProp}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
